import Translator from "bazinga-translator";

const loading = {};

const translator = {
  locale: null,
  loaded: [],
  trans(id, parameters, domain, locale) {
    if (!locale) {
      locale = getCurrentLocale();
    }

    if (!isLoaded(locale)) {
      this.load(locale);
      return "";
    }

    return trans(id, parameters, domain, locale);
  },
  transChoice(id, number, parameters, domain, locale) {
    if (!locale) {
      locale = getCurrentLocale();
    }

    if (!isLoaded(locale)) {
      this.load(locale);
      return "";
    }

    return transChoice(id, number, parameters, domain, locale);
  },
  async load(locale) {
    if (loading[locale] || isLoaded(locale)) {
      return;
    }

    loading[locale] = true;
    const module = await import(
      /* webpackChunkName: "translations" */ `@/translations/${locale}.json`
    );

    Translator.fromJSON(module.default);
    this.loaded.push(locale);

    return module.default;
  },
};

function isLoaded(locale) {
  return translator.loaded.indexOf(locale) >= 0;
}

function getCurrentLocale() {
  // if (!translator.locale) {
  //   throw new Error("Locale is not set");
  // }

  if (typeof translator.locale === "function") {
    return translator.locale();
  }

  return translator.locale;
}

function trans(id, parameters, domain, locale) {
  return Translator.trans(id, parameters, domain, locale);
}

function transChoice(id, number, parameters, domain, locale) {
  return Translator.transChoice(id, number, parameters, domain, locale);
}

export default translator;
